<div id="sh-create-organization-dialog-container-div" *transloco="let t">
	<ng-container *ngIf="formGroup">
		<form [formGroup]="formGroup">
			<prism-dialog id="sh-create-organization-content-div" confirm-button="" cancel-button="" visible="true">
				<h1 id="sh-create-organization-title-h1" slot="dialog-title">
					{{ t('cloud.shared.switch-org.create-organization') }}
				</h1>

				<div id="sh-create-organization-title-div">
					{{ t('cloud.shared.switch-org.provide-info-about-org') }}
				</div>
				<div id="sh-create-organization-dialog-content">
					<prism-input
						id="sh-create-organization-name-form-field"
						class="sh-account-form-input"
						angular-input
						formControlName="organizationName"
						[isValid]="!formGroup.get('organizationName')?.invalid"
						[placeholder]="t('cloud.shared.switch-org.organization-name')"
						required="true"
					>
						<span slot="label" id="sh-create-organization-name-form-label">
							{{ t('cloud.shared.switch-org.organization-name') }}
						</span>
					</prism-input>
					@if (getOrganizationNameError()) {
						<div id="sh-create-organization-error">
							<span class="prism-caption" id="sh-create-organization-name-error-span">{{
								getOrganizationNameError()
							}}</span>
						</div>
					}
					<prism-input
						id="sh-create-organization-company-name-field"
						formControlName="companyName"
						[placeholder]="t('cloud.shared.switch-org.company-name')"
						angular-input
						autocomplete="off"
						(valueInput)="onCompanyInput($event.detail)"
						(focus)="showCompanyList = true"
						[isValid]="!formGroup.get('companyName')?.invalid"
						(blur)="showCompanyList = false"
					>
						<span slot="label">
							{{ t('cloud.shared.switch-org.company-name') }}
						</span>

						<!-- Verified Icon -->
						@if (isCompanyVerified) {
							<prism-icon
								icon="verified"
								id="sh-create-organization-verify-icon"
								slot="icon-end"
								size="sm"
							></prism-icon>
						}
					</prism-input>
					<!-- Autocomplete Dropdown List -->
					@if (showCompanyList && filteredCompanyList.length > 0) {
						<div class="sh-create-organization-prism-autocomplete-container">
							<prism-list id="sh-change-organization-list">
								@for (option of filteredCompanyList; track option.companyName) {
									<prism-list-item
										(mousedown)="onCompanySelected(option)"
										id="sh-change-organization-list-item"
									>
										{{ option.companyName }}
										@if (option.isVerified) {
											<prism-icon
												icon="verified"
												id="sh-create-organization-verified-icon"
												size="sm"
											></prism-icon>
										}
									</prism-list-item>
								}
							</prism-list>
						</div>
					}
				</div>

				<!-- The below code can be uncommented when we support the verified organizations feature -->
				<!-- <ng-container *ngIf="!selectedCompanyOption?.isVerified">
					<mat-checkbox id="sh-create-organization-isverified-mat-checkbox" formControlName="isVerified">
						<mat-label id="sh-create-organization-isverified-mat-label">
							{{ t('cloud.shared.switch-org.verify-organization-label') }}
						</mat-label>
					</mat-checkbox>
				</ng-container> -->
				<div id="sh-create-organization-action-buttons-div">
					<prism-button variant="standard" (click)="closeDialog()" id="sh-create-organization-button-cancel">
						{{ t('cloud.shared.button-text.cancel') }}
					</prism-button>
					<prism-button
						[disabled]="formGroup.invalid"
						variant="standard"
						(click)="createOrganization()"
						id="sh-create-organization-create-org-button"
					>
						{{ t('cloud.shared.switch-org.create-view-organization') }}
					</prism-button>
				</div>
			</prism-dialog>
		</form>
	</ng-container>
</div>
